<app-card [titleKey]="translationKey + 'cardTitle'">
  <div>
    <label class="sub-section-header">{{
      translationKey + "additionalCosts" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails()
          .feesAndCostsChargedToInvestorIncludingAdministrativeCostsFromSaleOfCrowdfundingAssets
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "furtherInformation" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails()
          .whereAndHowToObtainFreeInformationOnCrowdfundingProjectProjectOwnerAndSpecialPurposeEntity
      }}
    </p>
  </div>
  <hr />
  <div>
    <label class="sub-section-header">{{
      translationKey + "howToComplain" | translate
    }}</label>
  </div>

  <div class="text-box">
    <p>
      {{
        projectDetails()
          .howAndWhereInvestorCanComplainAboutInvestmentOrConductOfProjectOwnerOrCrowdfundingServiceProvider
      }}
    </p>
  </div>
  <hr />
</app-card>
